export default __webpack_public_path__ + "static/media/whitesoul11.94665923.jpg";